export function formatWithSpaces(number: number) {
  return new Intl.NumberFormat('en-US', { style: 'decimal', useGrouping: true }).format(number).replace(/,/g, '\u00A0');
}
